const SizesUtils = require('../../../viscomjs/utils/SizesUtils');

module.exports = () => {
    const w = SizesUtils.winWidth();
    const h = SizesUtils.winHeight();

    if ((w < h && w < 425) || (w >= h && h < 600)) return 'mobile';
    return 'default';
};
